import React, { useState, useEffect, useContext } from 'react';
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, useRelationshipInjector } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";

import JSONPretty from 'react-json-pretty';

const dataProviderName = 'partnershipDeals/ruleset';

const Detail = (params) => {
    const { t } = useTranslation();
    const { close: closeDrawer } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [detailConfigLocal, setDetailConfigLocal] = useState();

    // DATA PROVIDER
    const { item, save, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);

    const { modelName, detailConfig } = existingModules[dataProviderName]

    useEffect(() => {
        if (!item?.data || !detailConfig) return;

        const detailConfigLocal = { ...detailConfig }
        const filterRoom = detailConfigLocal.tabs[0].fieldsets[0].fields.matchingVehicles.relation;
        filterRoom.filter = {};
        filterRoom.filter.items = (item.data?.rules ?? []).map((rule) => ({ field: rule.field, operator: rule.operator, value: rule.value }))
        filterRoom.filter.items.push({
            field: '_related_renter_name',
            operator: "equals",
            value: item.data?.deal?.renter?.name
        })
        filterRoom.filter.items.push({
            field: '_related_contract_contract_at',
            operator: "between",
            value: { "from": item.data?.deal?.start_at, "to": item.data?.deal?.end_at }
        })
        setDetailConfigLocal(detailConfigLocal)
    }, [detailConfig, item])

    useLoadOne({ loadOne, params, reloadCounter })

    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        save({ ...data, filters: params.filters /*, canReloadCounter:false*/ }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const [confirmDelete, setConfirmDelete] = useState()
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    return (
        <>
            {/* <JSONPretty data={item} className='json-wrapper' />
            <JSONPretty data={detailConfigLocal} className='json-wrapper' /> */}
            <DetailComponent
                {...params}
                values={{ ...item?.data }}
                modelName={modelName}
                detailConfig={detailConfigLocal}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={item?.data?.production ? t('Production ' + item?.data?.production) : t('New Ruleset')}
                subtitle={item?.data?.deal?.renter?.name}
                rightButtons={[
                    <SplitButton
                        actions={[
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                icon: "faTrash",
                                label: t('Delete'),
                                onClick: () => { handleDelete(item.data.id); }
                            }
                        ]}
                    />
                ]}
                {...params}
            />

            {confirmDelete}
        </>
    )
}

export default Detail;



